import { useRef } from "react";
import ModalPop from "../../home/ModalPop";
import menuOnClick from "../menuOnClick";

const MobileQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div className="block xl:hidden fixed left-0 bottom-0 w-full h-fit bg-white border rounded-t-2xl z-40">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="relative w-full h-fit grid grid-cols-5 justify-items-center text-center pt-1.5">
        <button type="button" onClick={openfunc}>
          <img src="/images/iconContact.png" alt="icon" width={40} height={40} className="mx-auto" />
          <small>견적문의</small>
        </button>
        <button type="button" onClick={() => menuOnClick("#blog")}>
          <img src="/images/iconReview.png" alt="icon" width={45} height={45} className="mx-auto" />
          <small>작업사례</small>
        </button>

        <button type="button" onClick={openfunc}>
          <img src="/images/iconBlog.png" alt="icon" width={25} height={25} className=" opacity-0" />
          <p>상담하기</p>
        </button>
        <button
          type="button"
          onClick={() => (window.location.href = "tel:010-9368-5332")}
          className="absolute bottom-1/2 left-1/2 -translate-x-8 w-16 h-16 rounded-full bg-white grid items-center justify-items-center boxshadow cursor-pointer"
        >
          <img src="/images/iconCall.png" alt="icon" width={50} height={50} className="mx-auto" />
        </button>
        <button type="button" onClick={() => window.open("https://blog.naver.com/gurobone1")}>
          <img src="/images/iconBlog.png" alt="icon" width={40} height={40} className="mx-auto rounded-full" />
          <small>블로그</small>
        </button>
        <button type="button" onClick={() => window.open("https://open.kakao.com/o/s3YAT29h")}>
          <img src="/images/iconKakao.png" alt="icon" width={40} height={40} className="mx-auto rounded-full" />
          <small>카톡상담</small>
        </button>
      </div>
    </div>
  );
};

export default MobileQuick;
